<template>
  <el-dialog
    :visible.sync="innerVisible"
    :title="this.$t('CargoMsg.Cargo_DestinationSelection')"
    width="660px"
    :close-on-click-modal="false"
  >
    <div class="app-main-page">
      <div class="app-main-inner-row">
        <div class="filters">
          <el-form :inline="true" label-width="50px" label-position="left">
            <el-form-item :label="$t('common.btn.query')">
              <el-input
                v-model="filter.likeName"
                :placeholder="$t('common.tips.fuzzySearch')"
                style="width:310px"
                no="1"
              />
            </el-form-item>
            <el-form-item>
              <el-button type="primary" no="2" @click="filter.pageNum=1;toQuery()">{{ $t('common.btn.query') }}</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div class="app-main-inner-row row-grid" style="min-height:300px;">
        <cargo-ag-grid
          :show-side-bar="false"
          :grid-options="gridOptions"
          :column-defs="columnDefs"
          :row-data="rowData"
          style="width: 100%;"
        />
      </div>
      <div class="app-main-inner-row row-pagination" style="padding-right:0;">
        <cargo-pagination
          :total="total"
          :page.sync="filter.pageNum"
          :limit.sync="filter.pageSize"
          @pagination="toQuery"
        />
      </div>
    </div>
    <span slot="footer">
      <el-button type="primary" no="3" @click="addHandler">{{ $t('common.btn.ok') }}</el-button>
      <el-button no="4" @click="cancelHandler">{{ $t('common.btn.cancel') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import * as destinationInlandLocationApi from '@/api/seaExport/destinationInlandLocation'
import { getLoading } from '@/utils/utilBaseElement'

export default {
  name: 'SelectSubLocDialog',
  props: {
    visible: { type: Boolean, required: true },
    type: { type: Number, required: true }
  },
  data() {
    return {
      innerVisible: false,
      filter: {
        likeName: '',
        pageNum: 1,
        pageSize: 50
      },
      total: 0,
      gridOptions: {
        rowSelection: 'single',
        suppressCellSelection: true,
        isRowSelectable: function(row) {
          return row.data && !row.data.isAdded
        },
        context: {
          componentParent: this
        },
        onRowDoubleClicked: this.addHandler
      },
      sideBarDefs: { toolPanels: ['columns', 'filter'], visible: false },
      columnDefs: [
        {
          headerName: this.$t('CargoMsg.Cargo_AciPortCode'),
          field: 'aciPortCode',
          width: 150,
          suppressMenu: true
        }, {
          headerName: this.$t('CargoMsg.Cargo_InlandLocation'),
          field: 'inlandLocation',
          width: 250,
          suppressMenu: true,
          tooltipValueGetter: (params) => params.value
        }, {
          headerName: this.$t('CargoMsg.Cargo_SubLocationCode'),
          field: 'subLocationCode',
          width: 200,
          suppressMenu: true
        }
      ],
      rowData: []
    }
  },
  watch: {
    visible(newVal) {
      this.innerVisible = newVal
    },
    innerVisible(newVal) {
      this.$emit('update:visible', newVal)
      if (!newVal) {
        this.initForm()
      }
    }
  },
  methods: {
    toQuery() {
      const params = {}
      params.likeName = this.filter.likeName
      params.pageNum = this.filter.pageNum
      params.pageSize = this.filter.pageSize
      const loading = getLoading()
      destinationInlandLocationApi.destinationInlandLocations(params).then(resp => {
        this.rowData = resp.data.list
        this.filter.pageNum = resp.data.pageNum
        this.filter.pageSize = resp.data.pageSize
        this.total = Number(resp.data.total)
      }).finally(() => loading.close())
    },
    addHandler() {
      const cell = this.gridOptions.api.getFocusedCell()
      const selectedRow = cell ? this.rowData[cell.rowIndex] : null
      this.$emit('select', selectedRow, this.type)
    },
    cancelHandler() {
      this.$emit('close')
    },
    initForm() {
      this.filter = {
        likeName: '',
        pageNum: 1,
        pageSize: 50
      }
      this.total = 0
      this.rowData = []
    }
  }
}
</script>

<style scoped>

</style>
